import { z } from 'zod';
import { SessionId } from './ids';

/**
 * Session snapshot stored in database
 * Contains a serialized Session state at a specific event count
 */
export const SessionSnapshotSchema = z.object({
  id: z.string(),
  sessionId: SessionId,
  snapshot: z.string(), // JSON-serialized Session (may be compressed)
  eventCount: z.number().int().nonnegative(), // Number of events replayed to create this snapshot
  createdAt: z.number(), // Timestamp when snapshot was created
  compressed: z.boolean().optional().default(false), // Whether snapshot is gzip-compressed
});

export type SessionSnapshot = z.infer<typeof SessionSnapshotSchema>;
